var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 8.89 8.5)",
    id: "dUVCF1qGSxkI-ZeJqbTeS"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(107,70,236)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-8.89, -8.5)",
    d: "M 14.8655 1.14207 C 13.7716 0.0632203 12.0071 0.0721473 10.9243 1.162 L 2.14685 9.99664 C 1.73493 10.4112 1.46454 10.9446 1.37405 11.521 L 0.789637 15.2435 C 0.658823 16.0768 1.39092 16.7903 2.22413 16.6415 L 5.91951 15.9819 C 6.48465 15.881 7.00473 15.6087 7.40864 15.2021 L 16.1941 6.35946 C 17.2769 5.26961 17.2679 3.51153 16.1741 2.43268 L 14.8655 1.14207 Z M 12.4428 2.65971 C 12.6955 2.40545 13.1071 2.40337 13.3623 2.65506 L 14.6709 3.94567 C 14.926 4.19736 14.9281 4.6075 14.6755 4.86176 L 5.8901 13.7044 C 5.79587 13.7993 5.67454 13.8628 5.5427 13.8863 L 3.09686 14.3229 L 3.4851 11.85 C 3.50621 11.7155 3.56929 11.5911 3.66539 11.4943 L 12.4428 2.65971 Z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilPurple);
export default __webpack_public_path__ + "static/media/pencil_purple.a0b3f01046ffb8c127cf622b77c7b92d.svg";
export { ForwardRef as ReactComponent };